module.exports = __webpack_public_path__ + "static/rdfa-twine-b8cb0c70146fa4069b0ffe5c1363feab.png";